/**
 * Client-side tenant-id generator. 16 chars from a 36-char lowercase
 * alphanumeric alphabet using unbiased rejection sampling over
 * Web Crypto bytes. 36^16 ≈ 8 × 10^24 combinations — collision
 * probability negligible at any realistic tenant count.
 */

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
const LENGTH = 16;

export function generateTenantId(): string {
  const acceptCeiling = 256 - (256 % ALPHABET.length);
  const out: string[] = [];
  const buffer = new Uint8Array(LENGTH * 2);
  let cursor = buffer.length;

  while (out.length < LENGTH) {
    if (cursor >= buffer.length) {
      crypto.getRandomValues(buffer);
      cursor = 0;
    }
    const byte = buffer[cursor]!;
    cursor += 1;
    if (byte >= acceptCeiling) continue;
    out.push(ALPHABET.charAt(byte % ALPHABET.length));
  }

  return out.join('');
}
